const stylesDashboard = {
  stack: {
    background: "linear-gradient(45deg, #7F8BFF, #55CEFF)",
    width: '100vw',
  },
  div: {
    display: "flex",
    flexWrap: 'nowrap',
    width:"60%",
    height:"90%",
  },
  divb: {
    width: "10rem",
    height: "10rem",
    borderRadius: "50rem",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#e0e0e0",
    marginTop: "7rem",
  },
  select: {
    marginTop: "10rem",
    marginLeft: "2.5rem",
  },
  icon: {
    marginLeft: "3rem",
  },
  title: {
    color: "white",
    fontSize: "2.5rem",
    fontFamily: "Raleway, sans-serif",
  },
  iconButton: {
    textDecoration: "none",
    color: "white",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
  },
  tabs: {
    marginLeft: "2rem",
    padding: "1rem 2rem",
  },
};

export default stylesDashboard;
